import React, { useEffect } from "react";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { Callback } from "./pages/login/Callback";
import LoginPage from "./pages/login/Login";
import { AuthProvider } from "./contexts/AuthContext";
import Dashboard from "./pages/dashboard/Dashboard";
import RequireAuth from "./route-guards/RequireAuth";
import Logout from "./pages/login/Logout";
import Unauthorized from "./pages/unauthorized/Unauthorized";
import RootLayout from "./pages/RootLayout";
import Users from "./pages/users/Users";
import CrossTabLogoutSync from "./contexts/CrossTabLogoutSync";
import "react-toastify/dist/ReactToastify.css";

function App() {
  // Listen for global "show-error" events (for snackbars)
  useEffect(() => {
    const handler = (e: Event) => {
      const customEvent = e as CustomEvent<string>;
      if (customEvent.detail) {
        toast.error(customEvent.detail, { position: "top-right" });
      }
    };
    window.addEventListener("show-error", handler);
    return () => window.removeEventListener("show-error", handler);
  }, []);

  return (
    <AuthProvider>
      <CrossTabLogoutSync />
      <Router>
        <Routes>
          {/* Public routes: NO layout */}
          <Route path="/auth" element={<LoginPage />} />
          <Route path="/auth/callback" element={<Callback />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/unauthorized" element={<Unauthorized />} />

          {/* Protected routes: with layout */}
          <Route path="/" element={<RequireAuth />}>
            <Route path="/" element={<RootLayout />}>
              <Route index element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/users" element={<Users />} />
              {/* ...other protected routes */}
            </Route>
          </Route>
        </Routes>
      </Router>
      {/* Snackbar/toast notifications */}
      <ToastContainer position="top-right" />
    </AuthProvider>
  );
}

export default App;
